import React from 'react'

import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import DomainIcon from '@material-ui/icons/Domain'

import PropertyValue from '../../../things/PropertyValue'
import Organization  from '../../../things/Organization'
import Thing         from '../../../things/Thing'

import ThingChildren, { styles } from '../ThingChildren'

class Department extends ThingChildren
{
    addMapUri = ( item , uri ) =>
    {
        if( item instanceof PropertyValue)
        {
            const { value } = item ;
            if( value instanceof Thing )
            {
                uri += '/' + value.id ;
            }
        }
        return uri ;
    };

    addPrepare = item =>
    {
        if( item )
        {
            const { value } = item ;
            return { value };
        }
        return null ;
    };

    getLocale = () => this.props.locale.things.organization.department ;
}

Department.defaultProps =
{
    ...ThingChildren.defaultProps ,
    clazz      : Organization,
    emptyClazz : PropertyValue,
    emptyIcon  : null ,
    icon       : <DomainIcon/> ,
    member     : 'department'
};

Department.propTypes =
{
    ...ThingChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( Department );